/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  MdClose,
  MdWheelchairPickup,
  MdAirlineSeatReclineExtra,
  MdFastfood,
  MdLuggage,
  MdFlightTakeoff,
  MdPerson,
  MdCheckCircle,
  MdArrowForward,
  MdReceiptLong,
} from 'react-icons/md';

import './AddSsrPage.scss';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { getObjectFromLS } from '../../shared/helper-utils/localStorage';
import {
  getFlightTicketApi,
  getPostBookingSeatLayoutApi,
  getPostBookingSsrApi,
  performPostBookingSsr,
  performticketing,
} from '../../api/flightApi';
import { seatGroupingHook } from './ssrGroupingHooks';
import { formatCurrency, isEmpty } from '../../shared/helper-utils/appUtils';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import SeatSelectionComponent from '../manage-booking/SeatSelectionComponent';
import MealSelectionComponent from '../manage-booking/MealSelectionComponent';
import BaggageSelectionComponent from '../manage-booking/BaggageSelectionComponent';
import SpecialSsrSelectionComponent from '../manage-booking/SpecialSsrSelectionComponent';
import AppButton from '../../shared/components/app-button/AppButton';
import AppModal from '../../shared/components/app-modal/AppModal';

function AddSsrPage() {
  const JOURNEY_TYPES = {
    ONWARD: 'onward',
    RETURN: 'return',
    ROUND_TRIP: 'roundtrip',
    ONE_WAY: 'oneway',
  };
  const ADDONS = {
    SEATS: 'seats',
    MEALS: 'meals',
    BAGGAGE: 'baggage',
    SPECIAL_SSR: 'special_ssr',
  };
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const { transactionId } = useParams();
  const totalFareRef = useRef(0);
  const flightLegsWithBaggageRef = useRef({});
  const flightLegsWithMealRef = useRef({});
  const flightLegsWithSpecialSsrRef = useRef({});
  const flightLegsWithSeatsRef = useRef({});
  const [alert, setAlert] = useState(undefined);
  const [userSelectedSsrRows, setUserSelectedSsrRows] = useState({});
  const [mealSelectionSector, setMealSelectionSector] = useState('');
  const [baggageSelectionSector, setBaggageSelectionSector] = useState('');
  const [specialSsrSelectionSector, setSpecialSsrSelectionSector] =
    useState('');
  const [showMeals, setShowMeals] = useState(false);
  const [showBaggage, setShowBaggage] = useState(false);
  const [showSpecialSsr, setShowSpecialSsr] = useState(false);
  const [showSeatMap, setShowSeatMap] = useState(false);
  const [isBaggageSelected, setIsBaggageSelected] = useState(false);
  const [isMealSelected, setIsMealSelected] = useState(false);
  const [isSpecialSsrSelected, setIsSpecialSsrSelected] = useState(false);
  const [activeSeatIndex, setActiveSeatIndex] = useState(0);
  const [activeBagIndex, setActiveBagIndex] = useState(0);
  const [activeMealIndex, setActiveMealIndex] = useState(0);
  const [activeSsrIndex, setActiveSsrIndex] = useState(0);
  const [seatSelectionSector, setSeatSelectionSector] = useState('');
  const [priceSummary, setPriceSummary] = useState([]);
  const [showPrice, setShowPrice] = useState(false);
  const userProfile = getObjectFromLS(APP_USER_PROFILE);
  const paxDetailsRef = useRef([]);
  const flightInvoiceRef = useRef({});
  const flightSectorsRef = useRef([]);
  const onwardSectorRef = useRef([]);
  const returnSectorRef = useRef([]);
  const passengerRef = useRef([]);
  const isOnwardConnectingFlightRef = useRef(false);
  const isReturnConnectingFlightRef = useRef(false);
  const originDestinationRef = useRef('');
  const destinationOriginRef = useRef('');
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showConfirmBookingPopup, setShowConfirmBookingPopup] = useState(false);
  const [isPostBookingSsrFlow, setIsPostBookingSsrFlow] = useState(false);
  const [isConfirmBookingFlow, setIsConfirmBookingFlow] = useState(false);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleAddAddOn = (addOnType) => {
    if (addOnType === ADDONS.MEALS) {
      if (Object.keys(flightLegsWithMealRef.current).length > 0) {
        setShowMeals(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Meal Failure',
          description:
            'Meals are not available at the moment, Please try later',
        });
      }
    } else if (addOnType === ADDONS.BAGGAGE) {
      if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
        setShowBaggage(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Baggage Failure',
          description:
            'Baggage selection is not available at the moment, Please try later',
        });
      }
    } else if (addOnType === ADDONS.SPECIAL_SSR) {
      if (Object.keys(flightLegsWithSpecialSsrRef.current).length > 0) {
        setShowSpecialSsr(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Special SSR Failure',
          description:
            'Special SSR selection is not available at the moment, Please try later',
        });
      }
    } else if (addOnType === ADDONS.SEATS) {
      if (Object.keys(flightLegsWithSeatsRef.current).length > 0) {
        setShowSeatMap(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Seat Failure',
          description:
            'Seats are not available at the moment, Please try later',
        });
      }
    }
  };

  const groupBySsrType = (response) => {
    try {
      if (
        response &&
        response.ApiStatus.Status === 'OK' &&
        response.ApiStatus.Result &&
        response.ApiStatus.Result.list &&
        response.ApiStatus.Result.list !== null
      ) {
        const { CarrierSSR } = response.ApiStatus.Result.list;
        const list = Array.isArray(CarrierSSR) ? CarrierSSR : [CarrierSSR];
        const groupedBySector = list.reduce((acc, cur) => {
          if (cur.ArrStation) {
            cur.origin = cur.DepStation;
            cur.destination = cur.ArrStation;
          }
          const key = `${cur.DepStation} - ${cur.ArrStation}`;
          if (acc[key]) {
            acc[key].push(cur);
          } else {
            acc[key] = [cur];
          }
          return acc;
        }, {});
        const sectors = Object.keys(groupedBySector);
        sectors.forEach((sector, index) => {
          const groupedData = groupedBySector[sector].reduce((acc, cur) => {
            if (acc[cur.ssrtype]) {
              acc[cur.ssrtype].push(cur);
            } else {
              acc[cur.ssrtype] = [cur];
            }
            return acc;
          }, {});
          if (groupedData.meal !== undefined) {
            groupedData.meal.sort(
              (meal1, meal2) => meal1.chargeableamount - meal2.chargeableamount,
            );
            flightLegsWithMealRef.current[sector] = groupedData.meal;
            if (Object.keys(flightLegsWithMealRef.current).length > 0) {
              setMealSelectionSector(
                Object.keys(flightLegsWithMealRef.current)[0],
              );
            }
          }
          if (groupedData.baggage !== undefined) {
            groupedData.baggage.sort(
              (baggage1, baggage2) =>
                baggage1.chargeableamount - baggage2.chargeableamount,
            );
            flightLegsWithBaggageRef.current[sector] = groupedData.baggage;
            if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
              setBaggageSelectionSector(
                Object.keys(flightLegsWithBaggageRef.current)[0],
              );
            }
          }

          if (groupedData.specialssr !== undefined) {
            groupedData.specialssr.sort(
              (baggage1, baggage2) =>
                baggage1.chargeableamount - baggage2.chargeableamount,
            );
            flightLegsWithSpecialSsrRef.current[sector] =
              groupedData.specialssr;
            if (Object.keys(flightLegsWithSpecialSsrRef.current).length > 0) {
              setSpecialSsrSelectionSector(
                Object.keys(flightLegsWithSpecialSsrRef.current)[0],
              );
            }
          }
        });
      } else {
        // setAlert({
        //   variant: 'error',
        //   title: 'SSR Failure',
        //   description: 'Failed to fetch SSR list. Please try again.',
        // });
      }
    } catch (error) {
      //
    }
  };

  const getSsrList = async () => {
    if (
      flightInvoiceRef.current.FlightRecord.JType.toLowerCase() ===
      JOURNEY_TYPES.ROUND_TRIP
    ) {
      const onwardResponse = await getPostBookingSsrApi(
        transactionId,
        JOURNEY_TYPES.ONWARD,
      );
      groupBySsrType(onwardResponse);
      const returnResponse = await getPostBookingSsrApi(
        transactionId,
        JOURNEY_TYPES.RETURN,
      );
      groupBySsrType(returnResponse);
    } else {
      const response = await getPostBookingSsrApi(
        transactionId,
        JOURNEY_TYPES.ONWARD,
      );
      groupBySsrType(response);
    }
  };

  const getSsrRows = (sector, list, ssrType) => {
    const sec = sector.split('-');
    const ssrList = [];

    list.forEach((traveller) => {
      const ssrItems = traveller.ssrRecord
        ? traveller.ssrRecord.filter(
            (ssr) =>
              ssr.SSRType === ssrType &&
              ssr.Origin === sec[0].trim() &&
              ssr.Destination === sec[1].trim(),
          )
        : undefined;
      if (ssrItems?.length > 0) {
        const ssrItem = ssrItems[0];
        ssrList.push({
          ssrcode: ssrItem ? ssrItem.SSRCode : '',
          ssrid: ssrItem ? ssrItem?.SSRCode : '',
          ssr_chargeableamount: ssrItem ? ssrItem.ChargeableAmount : '',
          tripnumber: traveller.SegmentNumber,
          jtype: traveller.SegmentNumber === 1 ? 'onward' : 'return',
          origin: ssrItem ? ssrItem.Origin : sec[0].trim(),
          destination: ssrItem ? ssrItem.Destination : sec[1].trim(),
          ssrtype: ssrType,
          ssrname: ssrItem ? ssrItem.SSR : '',
          paxtype: ssrItem ? ssrItem.PaxType : traveller.Type,
          paxid: traveller.Paxid,
          fullName: `${traveller.Title} ${traveller.FirstName} ${traveller.LastName}`,
          hasSsr: !!ssrItem,
        });
      } else {
        ssrList.push({
          ssrcode: '',
          ssrid: '',
          ssr_chargeableamount: '',
          tripnumber: traveller.SegmentNumber,
          jtype: traveller.SegmentNumber === 1 ? 'onward' : 'return',
          origin: sec[0].trim(),
          destination: sec[1].trim(),
          ssrtype: ssrType,
          ssrname: '',
          paxtype: traveller.Type,
          paxid: traveller.Paxid,
          fullName: `${traveller.Title} ${traveller.FirstName} ${traveller.LastName}`,
          hasSsr: false,
        });
      }
    });
    return ssrList;
  };

  const getUserSsr = () => {
    const userSelectedSsrRowsTemp = {};
    Object.keys(passengerRef.current).forEach((sector) => {
      const list = passengerRef.current[sector];
      userSelectedSsrRowsTemp[sector] = {
        baggageRows: getSsrRows(sector, list, 'baggage'),
        mealRows: getSsrRows(sector, list, 'meal'),
        seatRows: getSsrRows(sector, list, 'seat'),
        specialSsrRows: getSsrRows(sector, list, 'specialssr'),
      };
    });
    if (isOnwardConnectingFlightRef.current) {
      const list = passengerRef.current[originDestinationRef.current];
      userSelectedSsrRowsTemp[originDestinationRef.current] = {
        baggageRows: getSsrRows(originDestinationRef.current, list, 'baggage'),
        mealRows: getSsrRows(originDestinationRef.current, list, 'meal'),
        seatRows: getSsrRows(originDestinationRef.current, list, 'seat'),
        specialSsrRows: getSsrRows(
          originDestinationRef.current,
          list,
          'specialssr',
        ),
      };
    }

    if (isReturnConnectingFlightRef.current) {
      const list = passengerRef.current[destinationOriginRef.current];
      userSelectedSsrRowsTemp[destinationOriginRef.current] = {
        baggageRows: getSsrRows(destinationOriginRef.current, list, 'baggage'),
        mealRows: getSsrRows(destinationOriginRef.current, list, 'meal'),
        seatRows: getSsrRows(destinationOriginRef.current, list, 'seat'),
        specialSsrRows: getSsrRows(
          destinationOriginRef.current,
          list,
          'specialssr',
        ),
      };
    }
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const getSeatLayout = async () => {
    if (
      flightInvoiceRef.current.FlightRecord.JType.toLowerCase() ===
      JOURNEY_TYPES.ROUND_TRIP
    ) {
      const onwardSeatResponse = await getPostBookingSeatLayoutApi(
        transactionId,
        JOURNEY_TYPES.ONWARD,
      );
      const returnSeatResponse = await getPostBookingSeatLayoutApi(
        transactionId,
        JOURNEY_TYPES.RETURN,
      );
      if (
        onwardSeatResponse &&
        onwardSeatResponse.Root &&
        onwardSeatResponse.Root.Result &&
        onwardSeatResponse.Root.Result !== null &&
        onwardSeatResponse.Root.Result.list
      ) {
        const { SeatMap } = onwardSeatResponse.Root.Result.list;
        flightLegsWithSeatsRef.current = seatGroupingHook(
          SeatMap,
          flightLegsWithSeatsRef.current,
        );
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
      if (
        returnSeatResponse &&
        returnSeatResponse.Root &&
        returnSeatResponse.Root.Result &&
        returnSeatResponse.Root.Result !== null &&
        returnSeatResponse.Root.Result.list
      ) {
        const { SeatMap } = returnSeatResponse.Root.Result.list;
        flightLegsWithSeatsRef.current = seatGroupingHook(
          SeatMap,
          flightLegsWithSeatsRef.current,
        );
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
    } else {
      const response = await getPostBookingSeatLayoutApi(
        transactionId,
        JOURNEY_TYPES.ONWARD,
      );
      if (
        response &&
        response.Root &&
        response.Root.Result !== null &&
        response.Root.Result.list
      ) {
        const { SeatMap } = response.Root.Result.list;
        flightLegsWithSeatsRef.current = seatGroupingHook(
          SeatMap,
          flightLegsWithSeatsRef.current,
        );
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
    }
  };

  useEffect(() => {
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      if (currentParams.action === 'confirm') {
        setIsPostBookingSsrFlow(true);
        setIsConfirmBookingFlow(true);
      } else if (currentParams.action === 'hold') {
        setIsPostBookingSsrFlow(true);
        setIsConfirmBookingFlow(false);
      } else {
        setIsPostBookingSsrFlow(false);
        setIsConfirmBookingFlow(false);
      }
    }
  }, [searchParams]);

  const getData = async () => {
    setIsLoading(true);
    const response = await getFlightTicketApi(
      transactionId,
      userProfile.agentId,
    );
    const fullFlightDetails =
      response?.Result?.FullFlightDetails ||
      response?.FullFlightDetails ||
      response?.ApiStatus?.Result?.FullFlightDetails;

    if (fullFlightDetails && fullFlightDetails.FlightInvoice) {
      const { FlightInvoice } = fullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      let { SectorRecord } = flightInvoiceRef.current.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      flightSectorsRef.current = SectorRecord;
      flightSectorsRef.current.forEach((record) => {
        const arrDate = record.ArrivalDate;
        if (arrDate.toString().includes('-') === false) {
          const dateString = `${arrDate}`.replace(
            /(\d{4})(\d{2})(\d{2})/,
            '$1-$2-$3',
          );
          record.ArrivalDate = dateString;
        }
      });
      if (FlightInvoice.FlightRecord.JType === 'RoundTrip') {
        returnSectorRef.current = flightSectorsRef.current.filter(
          (x) => x.FlightType.toLowerCase() === 'return',
        );
        returnSectorRef.current = returnSectorRef.current.sort(
          (a, b) => a.SectorNumber - b.SectorNumber,
        );
        if (returnSectorRef.current.length > 1) {
          isReturnConnectingFlightRef.current = true;
        }
        destinationOriginRef.current = `${
          returnSectorRef.current[0].Origin
        } - ${
          returnSectorRef.current[returnSectorRef.current.length - 1]
            .Destination
        }`;
      }
      onwardSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType.toLowerCase() === 'onward',
      );
      if (onwardSectorRef.current.length > 1) {
        isOnwardConnectingFlightRef.current = true;
      }
      originDestinationRef.current = `${onwardSectorRef.current[0].Origin} - ${
        onwardSectorRef.current[onwardSectorRef.current.length - 1].Destination
      }`;
      let { PassengerSSRRecord } = flightInvoiceRef.current.PassengerSSRRecords;
      if (PassengerSSRRecord !== undefined && PassengerSSRRecord !== '') {
        PassengerSSRRecord = Array.isArray(PassengerSSRRecord)
          ? PassengerSSRRecord
          : [PassengerSSRRecord];
      } else {
        PassengerSSRRecord = [];
      }
      let { PassengerRecord } = flightInvoiceRef.current.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];
      passengerRef.current = {};
      const passengersBySegmentNumber = PassengerRecord.reduce((acc, cur) => {
        if (acc[cur.SegmentNumber]) {
          acc[cur.SegmentNumber].push(cur);
        } else {
          acc[cur.SegmentNumber] = [cur];
        }
        return acc;
      }, {});
      const ssrRecordsByTripNumber = PassengerSSRRecord.reduce((acc, cur) => {
        if (acc[cur.TripNumber]) {
          acc[cur.TripNumber].push(cur);
        } else {
          acc[cur.TripNumber] = [cur];
        }
        return acc;
      }, {});
      Object.keys(ssrRecordsByTripNumber).forEach((tripNumber) => {
        const ssrBySector = ssrRecordsByTripNumber[tripNumber].reduce(
          (acc, cur) => {
            const sector = `${cur.Origin} - ${cur.Destination}`;
            if (acc[sector]) {
              acc[sector].push(cur);
            } else {
              acc[sector] = [cur];
            }
            return acc;
          },
          {},
        );
        ssrRecordsByTripNumber[tripNumber] = ssrBySector;
      });

      SectorRecord.forEach((sectorRecord) => {
        const sector = `${sectorRecord.Origin} - ${sectorRecord.Destination}`;
        const tripNumberMapForSector = {
          onward: 1,
          return: 2,
        };
        const passengers =
          passengersBySegmentNumber[
            tripNumberMapForSector[sectorRecord.FlightType.toLowerCase()]
          ];
        if (
          ssrRecordsByTripNumber[
            tripNumberMapForSector[sectorRecord.FlightType.toLowerCase()]
          ]
        ) {
          const ssrRecords =
            ssrRecordsByTripNumber[
              tripNumberMapForSector[sectorRecord.FlightType.toLowerCase()]
            ][sector];
          if (ssrRecords) {
            passengers.forEach((passenger) => {
              const ssrRecord = ssrRecords.filter(
                (ssr) => ssr.Paxid === passenger.Paxid,
              );
              if (passenger.ssrRecord === undefined) {
                passenger.ssrRecord = ssrRecord;
              } else {
                passenger.ssrRecord = [...passenger.ssrRecord, ...ssrRecord];
              }
            });
          }
        }
        passengerRef.current[sector] = passengers;
      });

      if (
        isOnwardConnectingFlightRef.current &&
        passengerRef.current[originDestinationRef.current] === undefined
      ) {
        const passengers = passengersBySegmentNumber[1];
        if (ssrRecordsByTripNumber[1]) {
          const ssrRecords =
            ssrRecordsByTripNumber[1][originDestinationRef.current];
          if (ssrRecords) {
            passengers.forEach((passenger) => {
              const ssrRecord = ssrRecords.filter(
                (ssr) => ssr.Paxid === passenger.Paxid,
              );
              if (passenger.ssrRecord === undefined) {
                passenger.ssrRecord = ssrRecord;
              } else {
                passenger.ssrRecord = [...passenger.ssrRecord, ...ssrRecord];
              }
            });
          }
        }
        passengerRef.current[originDestinationRef.current] = passengers;
      }

      if (
        isReturnConnectingFlightRef.current &&
        passengerRef.current[destinationOriginRef.current] === undefined
      ) {
        const passengers = passengersBySegmentNumber[2];
        if (ssrRecordsByTripNumber[2]) {
          const ssrRecords =
            ssrRecordsByTripNumber[2][destinationOriginRef.current];
          if (ssrRecords) {
            passengers.forEach((passenger) => {
              const ssrRecord = ssrRecords.filter(
                (ssr) => ssr.Paxid === passenger.Paxid,
              );
              if (passenger.ssrRecord === undefined) {
                passenger.ssrRecord = ssrRecord;
              } else {
                passenger.ssrRecord = [...passenger.ssrRecord, ...ssrRecord];
              }
            });
          }
        }
        passengerRef.current[destinationOriginRef.current] = passengers;
      }
      if (isOnwardConnectingFlightRef.current) {
        passengerRef.current[originDestinationRef.current] =
          passengersBySegmentNumber['1'];
      }
      if (isReturnConnectingFlightRef.current) {
        passengerRef.current[destinationOriginRef.current] =
          passengersBySegmentNumber['2'];
      }
      getUserSsr();
      await getSsrList();
      await getSeatLayout();
      setIsLoading(false);
    } else {
      setAlert({
        variant: 'error',
        title: 'ADD SSR',
        description: 'SSR is not available at the moment, please try later',
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const updatePrice = (selectedSsrRows) => {
    let baggageCount = 0;
    let baggageSum = 0;
    let mealSum = 0;
    let mealCount = 0;
    let specailSsrSum = 0;
    let specialSsrCount = 0;
    let seatsSum = 0;
    let seatsCount = 0;
    let isShowPrice = false;
    Object.keys(selectedSsrRows).forEach((sector) => {
      const { baggageRows } = selectedSsrRows[sector];
      const { specialSsrRows } = selectedSsrRows[sector];
      const { mealRows } = selectedSsrRows[sector];
      const { seatRows } = selectedSsrRows[sector];
      baggageSum += baggageRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          baggageCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
      specailSsrSum += specialSsrRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          specialSsrCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
      mealSum += mealRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          mealCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
      seatsSum += seatRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          seatsCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
    });
    totalFareRef.current = baggageSum + mealSum + seatsSum + specailSsrSum;
    const summary = [];
    summary.push({
      show: baggageCount > 0,
      label: `${baggageCount} x Baggage`,
      value: baggageSum,
    });
    summary.push({
      show: mealCount > 0,
      label: `${mealCount} x Meal`,
      value: mealSum,
    });
    summary.push({
      show: seatsCount > 0,
      label: `${seatsCount} x Seat`,
      value: seatsSum,
    });
    summary.push({
      show: specialSsrCount > 0,
      label: `${specialSsrCount} x Special SSR`,
      value: specailSsrSum,
    });
    setShowPrice(isShowPrice);
    setPriceSummary(summary);
  };

  const getByName = (userBaggageRows) => {
    return userBaggageRows.reduce((acc, cur) => {
      if (acc[cur.fullName]) {
        acc[cur.fullName].push(cur);
      } else {
        acc[cur.fullName] = [cur];
      }
      return acc;
    }, {});
  };

  const handleAddBaggage = (baggage) => {
    const { origin, destination } = baggage;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].baggageRows
    ) {
      const userBaggageRows = userSelectedSsrRowsTemp[sector].baggageRows;
      const byName = getByName(userBaggageRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      let obj;
      if (firstRow && isEmpty(firstRow.ssrcode)) {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: baggage.ssrcode,
          ssrid: baggage.ssrid,
          ssrname: baggage.ssrname,
          ssr_chargeableamount: baggage.chargeableamount,
          origin:
            sector && sector.split('-')[0]
              ? sector.split('-')[0].trim()
              : firstRow.origin,
          destination:
            sector && sector.split('-')[1]
              ? sector.split('-')[1].trim()
              : firstRow.destination,
          ssrtype: 'baggage',
          hasSsr: false,
        };
      } else {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: baggage.ssrcode,
          ssrid: baggage.ssrid,
          ssrname: baggage.ssrname,
          ssr_chargeableamount: baggage.chargeableamount,
        };
      }
      userSelectedSsrRowsTemp[sector].baggageRows[activeBagIndex] = { ...obj };
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      const hasBaggageSelected = Object.keys(userSelectedSsrRowsTemp).some(
        (sKey) => {
          return userSelectedSsrRowsTemp[sKey].baggageRows.some(
            (traveller) => traveller.ssr_chargeableamount !== '',
          );
        },
      );
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setShowBaggage(false);
      setIsBaggageSelected(hasBaggageSelected);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };
  const handleRemoveBaggage = (baggage) => {
    const { origin, destination } = baggage;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].baggageRows
    ) {
      const userBaggageRows = userSelectedSsrRowsTemp[sector].baggageRows;
      const byName = getByName(userBaggageRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      const baggageIndex = userBaggageRows.findIndex(
        (b) =>
          b.hasSsr !== true &&
          b.fullName === fullName &&
          b.ssrcode === baggage.ssrcode,
      );
      userBaggageRows[baggageIndex] = {
        ...userBaggageRows[baggageIndex],
        ssrcode: '',
        ssrid: '',
        ssrname: '',
        ssr_chargeableamount: '',
      };
      userSelectedSsrRowsTemp[sector].baggageRows = userBaggageRows;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      const hasBaggageSelected = Object.keys(userSelectedSsrRowsTemp).some(
        (sKey) => {
          return userSelectedSsrRowsTemp[sKey].baggageRows.some(
            (traveller) => traveller.ssr_chargeableamount !== '',
          );
        },
      );
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setShowBaggage(false);
      setIsBaggageSelected(hasBaggageSelected);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const getSelectedBaggage = (userBaggageRows, fullName, sector) => {
    const filtered = userBaggageRows.filter(
      (row) => row.ssrname !== '' && row.ssr_chargeableamount !== '',
    );
    return filtered.length === 0 ? (
      'Select Baggage'
    ) : (
      <ul className="selected-meals">
        {filtered.map((baggage, bmi) => (
          <li key={bmi}>
            <span>
              {baggage.ssrname} • {formatCurrency(baggage.ssr_chargeableamount)}
            </span>
            {baggage.hasSsr !== true && (
              <AppIconButton
                onClick={() => handleRemoveBaggage(baggage, fullName, sector)}
                variant="secondary"
              >
                <MdClose />
              </AppIconButton>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleAddMeal = (ssr) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].mealRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].mealRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      let obj;
      if (firstRow && isEmpty(firstRow.ssrcode)) {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
          origin:
            sector && sector.split('-')[0]
              ? sector.split('-')[0].trim()
              : firstRow.origin,
          destination:
            sector && sector.split('-')[1]
              ? sector.split('-')[1].trim()
              : firstRow.destination,
          ssrtype: 'meal',
          hasSsr: false,
        };
      } else {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
        };
      }
      userSelectedSsrRowsTemp[sector].mealRows[activeMealIndex] = { ...obj };
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setShowMeals(false);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const handleRemoveMeal = (ssr) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].mealRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].mealRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      const baggageIndex = userSsrRows.findIndex(
        (b) =>
          b.hasSsr !== true &&
          b.fullName === fullName &&
          b.ssrcode === ssr.ssrcode,
      );
      userSsrRows[baggageIndex] = {
        ...userSsrRows[baggageIndex],
        ssrcode: '',
        ssrid: '',
        ssrname: '',
        ssr_chargeableamount: '',
      };
      userSelectedSsrRowsTemp[sector].mealRows = userSsrRows;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setShowMeals(false);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const getSelectedMeals = (userSsrRows, fullName, sector) => {
    const filtered = userSsrRows.filter(
      (row) => row.ssrname !== '' && row.ssr_chargeableamount !== '',
    );
    return filtered.length === 0 ? (
      'Select Meal'
    ) : (
      <ul className="selected-meals">
        {filtered.map((ssr, bmi) => (
          <li key={bmi}>
            <span>
              {ssr.ssrname} • {formatCurrency(ssr.ssr_chargeableamount)}
            </span>
            {ssr.hasSsr !== true && (
              <AppIconButton
                onClick={() => handleRemoveMeal(ssr, fullName, sector)}
                variant="secondary"
              >
                <MdClose />
              </AppIconButton>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleProceed = async () => {
    setIsLoading(true);
    const ssrList = [];
    Object.keys(userSelectedSsrRows).forEach((sector) => {
      userSelectedSsrRows[sector].baggageRows.forEach((row) => {
        if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
          delete row.fullName;
          delete row.hasSsr;
          ssrList.push(row);
        }
      });

      userSelectedSsrRows[sector].mealRows.forEach((row) => {
        if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
          delete row.fullName;
          delete row.hasSsr;
          ssrList.push(row);
        }
      });
      userSelectedSsrRows[sector].specialSsrRows.forEach((row) => {
        if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
          delete row.fullName;
          delete row.hasSsr;
          ssrList.push(row);
        }
      });
      userSelectedSsrRows[sector].seatRows.forEach((row) => {
        if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
          delete row.fullName;
          delete row.hasSsr;
          ssrList.push(row);
        }
      });
    });
    const response = await performPostBookingSsr(transactionId, ssrList);
    if (response && response.ApiStatus.Status === 'OK') {
      if (isPostBookingSsrFlow) {
        if (!isConfirmBookingFlow) {
          setAlert({
            variant: 'success',
            title: 'Hold Confirmation',
            description:
              'SSR added successfully. Redirecting to ticket page...',
          });
          setIsLoading(false);
          setTimeout(() => {
            navigate(`/flight/ticket/${transactionId}`);
          }, 2000);
          return;
        }
        const res = await performticketing(transactionId);
        if (res) {
          if (res.ApiStatus) {
            if (res.ApiStatus.Status === 'OK') {
              setAlert({
                variant: 'success',
                title: 'Confirm Booking',
                description: 'Redirecting to ticket page...',
              });
              setTimeout(() => {
                navigate(
                  `${NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE}/${res.ApiStatus.Result}`,
                );
              }, 2000);
            } else {
              setAlert({
                variant: 'error',
                title: 'Confirm Booking',
                description: res.ApiStatus.Message,
              });
            }
          } else if (res.Root) {
            if (res.Root.Status === 'OK') {
              setAlert({
                variant: 'success',
                title: 'Add SSR',
                description: 'Redirecting to ticket page...',
              });
              setTimeout(() => {
                navigate(
                  `${NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE}/${res.Root.Result}`,
                );
              }, 2000);
            } else {
              setAlert({
                variant: 'error',
                title: 'Add SSR',
                description: res.Root.Message,
              });
            }
          }
        } else {
          setAlert({
            variant: 'error',
            title: 'Add SSR',
            description: res.ApiStatus.Message,
          });
        }
        setIsLoading(false);
        setTimeout(() => {
          navigate(`/flight/ticket/${transactionId}`);
        }, 2000);
      } else {
        setAlert({
          variant: 'success',
          title: 'SSR Success',
          description:
            'You have successfully booked a SSR, Redirecting to ticket page...',
        });
        setIsLoading(false);
        setTimeout(() => {
          navigate(`/flight/ticket/${transactionId}`);
        }, 2000);
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'SSR Booking Failed',
        description: response?.ApiStatus?.Message,
      });
      setIsLoading(false);
    }
  };

  const handlePerformTicketing = async () => {
    setIsLoading(true);
    const res = await performticketing(transactionId);
    if (res) {
      if (res.ApiStatus) {
        if (res.ApiStatus.Status === 'OK') {
          setAlert({
            variant: 'success',
            title: 'Confirm Booking',
            description: 'Redirecting to ticket page...',
          });
          setTimeout(() => {
            navigate(
              `${NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE}/${res.ApiStatus.Result}`,
            );
          }, 2000);
        } else {
          setAlert({
            variant: 'error',
            title: 'Confirm Booking',
            description: res.ApiStatus.Message,
          });
        }
      } else if (res.Root) {
        if (res.Root.Status === 'OK') {
          setAlert({
            variant: 'success',
            title: 'Add SSR',
            description: 'Redirecting to ticket page...',
          });
          setTimeout(() => {
            navigate(
              `${NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE}/${res.Root.Result}`,
            );
          }, 2000);
        } else {
          setAlert({
            variant: 'error',
            title: 'Confirm Booking',
            description: res.Root.Message,
          });
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Confirm Booking',
        description: res.ApiStatus.Message,
      });
    }
    setIsLoading(false);
    setTimeout(() => {
      navigate(`/flight/ticket/${transactionId}`);
    }, 2000);
    setIsLoading(false);
  };

  const handleAddSpecialSsr = (ssr) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].specialSsrRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].specialSsrRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      let obj;
      if (firstRow && isEmpty(firstRow.ssrcode)) {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
          origin:
            sector && sector.split('-')[0]
              ? sector.split('-')[0].trim()
              : firstRow.origin,
          destination:
            sector && sector.split('-')[1]
              ? sector.split('-')[1].trim()
              : firstRow.destination,
        };
      } else {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
        };
      }
      userSelectedSsrRowsTemp[sector].specialSsrRows[activeSsrIndex] = {
        ...obj,
      };
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      const hasBaggageSelected = Object.keys(userSelectedSsrRowsTemp).some(
        (sKey) => {
          return userSelectedSsrRowsTemp[sKey].specialSsrRows.some(
            (traveller) => traveller.ssr_chargeableamount !== '',
          );
        },
      );
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setShowBaggage(false);
      setIsBaggageSelected(hasBaggageSelected);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };
  const handleRemoveSpecialSsr = (ssr) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].specialSsrRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].specialSsrRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      const baggageIndex = userSsrRows.findIndex(
        (b) =>
          b.hasSsr !== true &&
          b.fullName === fullName &&
          b.ssrcode === ssr.ssrcode,
      );
      userSsrRows[baggageIndex] = {
        ...userSsrRows[baggageIndex],
        ssrcode: '',
        ssrid: '',
        ssrname: '',
        ssr_chargeableamount: '',
      };
      userSelectedSsrRowsTemp[sector].specialSsrRows = userSsrRows;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      const hasBaggageSelected = Object.keys(userSelectedSsrRowsTemp).some(
        (sKey) => {
          return userSelectedSsrRowsTemp[sKey].specialSsrRows.some(
            (traveller) => traveller.ssr_chargeableamount !== '',
          );
        },
      );
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setShowBaggage(false);
      setIsBaggageSelected(hasBaggageSelected);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const getSelectedSpecailSsr = (userSpecialSsrRows, fullName, sector) => {
    const filtered = userSpecialSsrRows.filter(
      (row) => row.ssrname !== '' && row.ssr_chargeableamount !== '',
    );
    return filtered.length === 0 ? (
      'Select Special SSR'
    ) : (
      <ul className="selected-meals">
        {filtered.map((ssr, bmi) => (
          <li key={bmi}>
            <span>
              {ssr.ssrname} • {formatCurrency(ssr.ssr_chargeableamount)}
            </span>
            {ssr.hasSsr !== true && (
              <AppIconButton
                onClick={() => handleRemoveSpecialSsr(ssr, fullName, sector)}
                variant="secondary"
              >
                <MdClose />
              </AppIconButton>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleSeatSelection = (seat, sector) => {
    if (seat.seatstatus === 'Open') {
      const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
      if (userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].hasSsr) {
        setAlert({
          title: 'Seat Selection',
          description: `You have already booked ${userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode} seat. You can't book another seat.`,
          variant: 'warn',
        });
      } else if (
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode !==
          seat.seatdesignator &&
        userSelectedSsrRowsTemp[sector].seatRows.filter(
          (x) => x.ssrcode === seat.seatdesignator,
        ).length > 0
      ) {
        setAlert({
          title: 'Seat Selection',
          description:
            'This seat has been reserved for other passenger. Please choose a different seat.',
          variant: 'warn',
        });
      } else if (
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode ===
        seat.seatdesignator
      ) {
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode = '';
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid = '';
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname = '';
        userSelectedSsrRowsTemp[sector].seatRows[
          activeSeatIndex
        ].ssr_chargeableamount = '';
      } else {
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode =
          seat.seatdesignator;
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid =
          seat.seatgroup;
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
          seat.seatgroup;
        userSelectedSsrRowsTemp[sector].seatRows[
          activeSeatIndex
        ].ssr_chargeableamount = seat.seatprice;
      }
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
      setShowSeatMap(false);
    }
  };

  const handleRemoveSeat = (seat, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode = '';
    userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid = '';
    userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname = '';
    userSelectedSsrRowsTemp[sector].seatRows[
      activeSeatIndex
    ].ssr_chargeableamount = '';

    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
    updatePrice(userSelectedSsrRowsTemp);
    setShowSeatMap(false);
  };

  const handleConfirmPopupClose = (isConfirm) => {
    setShowConfirmPopup(false);
    if (isConfirm) {
      handleProceed();
    }
  };
  const handleConfirmBookingPopupClose = (isConfirm) => {
    setShowConfirmBookingPopup(false);
    if (isConfirm) {
      if (isConfirmBookingFlow) {
        handlePerformTicketing();
      } else {
        setAlert({
          variant: 'success',
          title: 'Hold Confirmation',
          description:
            'Hold confirmed successfully, redirecting to ticket page',
        });
        setTimeout(() => {
          navigate(`/flight/ticket/${transactionId}`);
        }, 2000);
      }
    }
  };

  const firstSectorKey =
    passengerRef.current && Object.keys(passengerRef.current).length > 0
      ? Object.keys(passengerRef.current)[0]
      : null;
  const passengersList =
    firstSectorKey && passengerRef.current[firstSectorKey]
      ? passengerRef.current[firstSectorKey]
      : [];

  const isSeatSelected = priceSummary.some(
    (p) => p.label.toLowerCase().includes('seat') && p.show,
  );
  const isBaggageActive =
    priceSummary.some(
      (p) => p.label.toLowerCase().includes('baggage') && p.show,
    ) || isBaggageSelected;
  const isMealActive =
    priceSummary.some(
      (p) => p.label.toLowerCase().includes('meal') && p.show,
    ) || isMealSelected;
  const isSpecialSsrActive =
    priceSummary.some(
      (p) => p.label.toLowerCase().includes('special') && p.show,
    ) || isSpecialSsrSelected;

  return (
    <section className="add-ssr-page mb-5">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          description={alert.description}
          variant={alert.variant}
          onHide={() => setAlert(undefined)}
        />
      )}
      <div className="add-ssr-container">
        {/* Header Hero Banner */}
        <div className="add-ssr-header-card">
          <div className="add-ssr-header-card__content">
            {transactionId && (
              <div className="add-ssr-header-card__badge">
                <MdFlightTakeoff className="me-1" /> Booking ID: {transactionId}
              </div>
            )}
            <h1 className="add-ssr-header-card__title">
              Add Special Services (SSR)
            </h1>
            <p className="add-ssr-header-card__subtitle">
              Personalize your flight with seats, extra baggage allowance,
              delicious meals, and special assistance.
            </p>
          </div>
        </div>

        {/* Travellers Section */}
        {passengersList && passengersList.length > 0 && (
          <section className="add-ssr-card">
            <div className="add-ssr-card__header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <div className="add-ssr-card__icon-badge">
                  <MdPerson />
                </div>
                <div>
                  <h4 className="add-ssr-card__title mb-0">Travellers</h4>
                  <span className="add-ssr-card__subtitle">
                    Select add-ons for your passengers
                  </span>
                </div>
              </div>
              <span className="badge rounded-pill bg-light text-dark border px-3 py-2">
                {passengersList.length} Passenger
                {passengersList.length > 1 ? 's' : ''}
              </span>
            </div>
            <div className="add-ssr-card__body">
              <div className="passenger-pills-grid">
                {passengersList.map((pax, idx) => (
                  <div className="passenger-pill-card" key={pax.Paxid || idx}>
                    <div className="passenger-avatar">
                      {pax.FirstName ? pax.FirstName[0].toUpperCase() : 'P'}
                    </div>
                    <div className="passenger-info">
                      <div className="passenger-name">
                        {pax.Title} {pax.FirstName} {pax.LastName}
                      </div>
                      <div className="passenger-type">
                        {pax.PaxType || pax.UserCategory || 'Passenger'}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Pick Your Add-ons Grid */}
        <section className="add-ssr-card">
          <div className="add-ssr-card__header">
            <h4 className="add-ssr-card__title mb-0">Pick your add-ons</h4>
            <span className="add-ssr-card__subtitle">
              Choose from available services to personalize your journey
            </span>
          </div>
          <div className="add-ssr-card__body">
            <div className="addons-grid">
              {/* Seat Selection Card */}
              <div
                role="button"
                tabIndex={0}
                className={`addon-card ${
                  isSeatSelected ? 'addon-card--active' : ''
                }`}
                onClick={() => handleAddAddOn(ADDONS.SEATS)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleAddAddOn(ADDONS.SEATS);
                  }
                }}
              >
                <div className="addon-card__icon-wrapper addon-card__icon-wrapper--seats">
                  <MdAirlineSeatReclineExtra size={28} />
                </div>
                <div className="addon-card__content">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <h5 className="addon-card__title">Seat Selection</h5>
                    {isSeatSelected && (
                      <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill">
                        <MdCheckCircle className="me-1" /> Selected
                      </span>
                    )}
                  </div>
                  <p className="addon-card__desc">
                    Choose window, aisle, or extra legroom seats.
                  </p>
                  <div className="addon-card__action">
                    <span>
                      {isSeatSelected ? 'Modify Seats' : 'Select Seats'}
                    </span>
                    <MdArrowForward className="action-arrow" />
                  </div>
                </div>
              </div>

              {/* Baggage Card */}
              <div
                role="button"
                tabIndex={0}
                className={`addon-card ${
                  isBaggageActive ? 'addon-card--active' : ''
                }`}
                onClick={() => handleAddAddOn(ADDONS.BAGGAGE)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleAddAddOn(ADDONS.BAGGAGE);
                  }
                }}
              >
                <div className="addon-card__icon-wrapper addon-card__icon-wrapper--baggage">
                  <MdLuggage size={28} />
                </div>
                <div className="addon-card__content">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <h5 className="addon-card__title">Extra Baggage</h5>
                    {isBaggageActive && (
                      <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill">
                        <MdCheckCircle className="me-1" /> Selected
                      </span>
                    )}
                  </div>
                  <p className="addon-card__desc">
                    Pre-book extra baggage capacity for your trip.
                  </p>
                  <div className="addon-card__action">
                    <span>
                      {isBaggageActive ? 'Modify Baggage' : 'Add Baggage'}
                    </span>
                    <MdArrowForward className="action-arrow" />
                  </div>
                </div>
              </div>

              {/* Meal Card */}
              <div
                role="button"
                tabIndex={0}
                className={`addon-card ${
                  isMealActive ? 'addon-card--active' : ''
                }`}
                onClick={() => handleAddAddOn(ADDONS.MEALS)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleAddAddOn(ADDONS.MEALS);
                  }
                }}
              >
                <div className="addon-card__icon-wrapper addon-card__icon-wrapper--meals">
                  <MdFastfood size={28} />
                </div>
                <div className="addon-card__content">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <h5 className="addon-card__title">In-flight Meals</h5>
                    {isMealActive && (
                      <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill">
                        <MdCheckCircle className="me-1" /> Selected
                      </span>
                    )}
                  </div>
                  <p className="addon-card__desc">
                    Pre-order hot meals & beverages for your flight.
                  </p>
                  <div className="addon-card__action">
                    <span>
                      {isMealActive ? 'Modify Meals' : 'Select Meals'}
                    </span>
                    <MdArrowForward className="action-arrow" />
                  </div>
                </div>
              </div>

              {/* Special SSR Card */}
              <div
                role="button"
                tabIndex={0}
                className={`addon-card ${
                  isSpecialSsrActive ? 'addon-card--active' : ''
                }`}
                onClick={() => handleAddAddOn(ADDONS.SPECIAL_SSR)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleAddAddOn(ADDONS.SPECIAL_SSR);
                  }
                }}
              >
                <div className="addon-card__icon-wrapper addon-card__icon-wrapper--special">
                  <MdWheelchairPickup size={28} />
                </div>
                <div className="addon-card__content">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <h5 className="addon-card__title">Special SSR</h5>
                    {isSpecialSsrActive && (
                      <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill">
                        <MdCheckCircle className="me-1" /> Selected
                      </span>
                    )}
                  </div>
                  <p className="addon-card__desc">
                    Wheelchair access and special assistance requests.
                  </p>
                  <div className="addon-card__action">
                    <span>
                      {isSpecialSsrActive
                        ? 'Modify Special SSR'
                        : 'Request Assistance'}
                    </span>
                    <MdArrowForward className="action-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Price Breakdown */}
        {showPrice && (
          <section className="add-ssr-card price-summary-card">
            <div className="add-ssr-card__header d-flex align-items-center gap-2">
              <div className="add-ssr-card__icon-badge add-ssr-card__icon-badge--receipt">
                <MdReceiptLong />
              </div>
              <div>
                <h4 className="add-ssr-card__title mb-0">Price Breakdown</h4>
                <span className="add-ssr-card__subtitle">
                  Summary of your selected add-ons
                </span>
              </div>
            </div>
            <div className="add-ssr-card__body">
              <div className="price-rows-container">
                {priceSummary.map(
                  (price, index) =>
                    price.show && (
                      <div
                        key={index}
                        className="price-row d-flex justify-content-between align-items-center py-2"
                      >
                        <span className="price-row__label">{price.label}</span>
                        <span className="price-row__value fw-semibold">
                          {formatCurrency(price.value)}
                        </span>
                      </div>
                    ),
                )}
                <div className="price-row-divider" />
                <div className="price-row price-row--total d-flex justify-content-between align-items-center pt-2">
                  <span className="price-row__total-label">Total Amount</span>
                  <span className="price-row__total-value">
                    {formatCurrency(totalFareRef.current)}
                  </span>
                </div>
              </div>
            </div>
          </section>
        )}

        {showSeatMap &&
          Object.keys(flightLegsWithSeatsRef.current).length > 0 && (
            <SeatSelectionComponent
              showSeatMap={showSeatMap}
              setShowSeatMap={setShowSeatMap}
              flightLegsWithSeatsRef={flightLegsWithSeatsRef.current}
              userSelectedSsrRows={userSelectedSsrRows}
              activeSeatIndex={activeSeatIndex}
              seatSelectionSector={seatSelectionSector}
              setSeatSelectionSector={setSeatSelectionSector}
              setActiveSeatIndex={setActiveSeatIndex}
              isNormalBooking={false}
              handleRemoveSeat={handleRemoveSeat}
              handleSeatSelection={handleSeatSelection}
            />
          )}

        {showMeals && (
          <MealSelectionComponent
            showMeals={showMeals}
            setShowMeals={setShowMeals}
            flightLegsWithMealRef={flightLegsWithMealRef.current}
            mealSelectionSector={mealSelectionSector}
            setMealSelectionSector={setMealSelectionSector}
            userSelectedSsrRows={userSelectedSsrRows}
            activeMealIndex={activeMealIndex}
            setActiveMealIndex={setActiveMealIndex}
            getSelectedMeals={getSelectedMeals}
            handleRemoveMeal={handleRemoveMeal}
            handleAddMeal={handleAddMeal}
            isNormalBooking={false}
          />
        )}

        {showBaggage && (
          <BaggageSelectionComponent
            showBaggage={showBaggage}
            setShowBaggage={setShowBaggage}
            flightLegsWithBaggageRef={flightLegsWithBaggageRef.current}
            baggageSelectionSector={baggageSelectionSector}
            setBaggageSelectionSector={setBaggageSelectionSector}
            userSelectedSsrRows={userSelectedSsrRows}
            activeBagIndex={activeBagIndex}
            setActiveBagIndex={setActiveBagIndex}
            getSelectedBaggage={getSelectedBaggage}
            handleRemoveBaggage={handleRemoveBaggage}
            handleAddBaggage={handleAddBaggage}
            isNormalBooking={false}
          />
        )}

        {showSpecialSsr && (
          <SpecialSsrSelectionComponent
            showSpecialSsr={showSpecialSsr}
            setShowSpecialSsr={setShowSpecialSsr}
            flightLegsWithSpecialSsr={flightLegsWithSpecialSsrRef.current}
            handleAddSpecialSsr={handleAddSpecialSsr}
            specialSsrSelectionSector={specialSsrSelectionSector}
            setSpecialSsrSelectionSector={setSpecialSsrSelectionSector}
            userSelectedSsrRows={userSelectedSsrRows}
            activeSsrIndex={activeSsrIndex}
            setActiveSsrIndex={setActiveSsrIndex}
            getSelectedSpecailSsr={getSelectedSpecailSsr}
            handleRemoveSpecialSsr={handleRemoveSpecialSsr}
            isNormalBooking={false}
          />
        )}

        <div className="add-ssr-actions text-center">
          <AppButton
            onClick={() => {
              if (isPostBookingSsrFlow && !showPrice) {
                setShowConfirmBookingPopup(true);
              } else {
                setShowConfirmPopup(true);
              }
            }}
            disabled={isPostBookingSsrFlow ? false : !showPrice}
            className="proceed-ssr-btn"
            btnText="Proceed with Selection"
          />
        </div>
      </div>

      {showConfirmPopup && (
        <AppModal
          modalTitle="Selected SSRs Confirmation"
          onModalClose={handleConfirmPopupClose}
          okText="Confirm"
          cancelText="Cancel"
          showFooter
        >
          <p>Review and confirm your chosen SSRs.</p>
          {priceSummary.map(
            (price, index) =>
              price.show && (
                <div
                  key={index}
                  className="d-flex justify-content-between w-100 px-3 py-1"
                >
                  <span>{price.label}</span>
                  <span className="fw-500 fs-5">
                    {formatCurrency(price.value)}
                  </span>
                </div>
              ),
          )}
          <div className="w-100 px-3 py-2">
            <hr className="mb-0 mt-0" />
          </div>
          <div className="d-flex justify-content-between w-100 px-3 py-1">
            <span className="fs-5 fw-bold">Total</span>
            <span className="fw-bold fs-5 text-primary">
              {formatCurrency(totalFareRef.current)}
            </span>
          </div>
        </AppModal>
      )}

      {showConfirmBookingPopup && (
        <AppModal
          modalTitle={isConfirmBookingFlow ? 'Confirm Booking' : 'Confirm Hold'}
          onModalClose={handleConfirmBookingPopupClose}
          okText="Confirm"
          cancelText="Cancel"
          showFooter
        >
          <p>Are you sure you want to continue without adding SSR?</p>
        </AppModal>
      )}
    </section>
  );
}

export default AddSsrPage;
